import { render, staticRenderFns } from "./UploadParams.vue?vue&type=template&id=71cfebcb&"
import script from "./UploadParams.vue?vue&type=script&lang=js&"
export * from "./UploadParams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports